export default __webpack_public_path__ + "static/media/pxiEyp8kv8JHgFVrJJfecg.5224cd4c.woff2";